// removed by extract-text-webpack-plugin
module.exports = {"headingDefaults":"TTaPsM4e_kKBsL0kQREZO"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/Text/styles.scss
// module id = ./node_modules/wix-style-react/dist/es/src/Text/styles.scss
// module chunks = 0